import { useEffect } from 'react';
import { sendAdobeAnalyticsError } from 'ciam-self-service-shared';

const useAdobeAnalyticsError = (error) => {
  useEffect(() => {
    if (error?.errorCode) {
      sendAdobeAnalyticsError({
        error: {
          errorCode: error?.errorCode,
          errorType: error?.errorType,
          errorDescription: error?.description,
        },
      });
    }
  }, [error]);
};

export default useAdobeAnalyticsError;
